<template>
    <div class="p-editor ui-editor">
    	<transition
			name="ui-sidebar"
		    enter-active-class="animated animatefast fadeInLeft"
		    leave-active-class="animated animatefast fadeOutLeft">
	    	<div class="ui-editor__sidebar" v-if="charts">
				<c-editor-sidebar></c-editor-sidebar>
			</div>
		</transition>

		<div class="ui-editor__main">
			<v-modal v-if="saveing" :options="(false === true)">
				<div v-cloak slot="title">Speichern</div>
				<div v-cloak slot="message">Dieser vorgang kann einige Sekunden dauern.</div>
			</v-modal>

			<div v-if="!loading">
				<c-editor-presentation v-if="presentation_type == 'user'" :uid="uid"></c-editor-presentation>
				<c-editor-presentation v-else-if="presentation_type == 'presentation'" :pid="pid"></c-editor-presentation>
				<c-editor-presentation v-else-if="presentation_type == 'master'" :master="true"></c-editor-presentation>
				<c-editor-presentation v-else :master="false"></c-editor-presentation>
			</div>
		</div>

		<c-editor-addablechart-modal></c-editor-addablechart-modal>
    </div>
</template>

<script>
// Base
import Vue from 'vue';

// Componenets
import CEditorSidebar from '@/components/p-editor/c-editor-sidebar';
import CEditorPresentation from '@/components/p-editor/c-editor-presentation';
import CEditorAddablechartModal from '@/components/p-editor/c-editor-addablechart-modal';


import VEditable 			from '@/components/v-editable';

// funktion
import newVueChart from '@/helpers/newChart';

// helper
import help_chart from '@/helpers/chart';
import help_rest from '@/helpers/rest';

if(!window.chartcomponents) window.chartcomponents = [];

export default {
	name: 'p-editor',
	components: {
		CEditorAddablechartModal,
		CEditorSidebar,
		CEditorPresentation,
		VEditable
	},
	data(){
		return {
			data: {
				_socketid: false
			},
		}
	},
	watch: {
		'$route': 'routerupdate'
	},
	props: {
		uid: {
			default: ''
		},
		pid: {
			default: ''
		},
		master: {
			default: false
		}
	},

	computed: {
		presentation_type() {
			return this.$store.getters.presentation.type;
		},
		presentation(){
			return this.$store.getters.presentation;
		},
		channel(){
			return this.$store.getters.channel;
		},
		charts(){
			return this.$store.getters.charts;
		},
		changed(){
			return this.$store.getters.changed;
		},
		addchart(){
			return this.$store.getters.addchart;
		},
		editing(){
			return this.$store.getters.editing;
		},
		loading(){
			return this.$store.getters.loading;
		},
		saveing(){
			return this.$store.getters.saveing;
		},
	},

	mounted(){
		this.$store.commit('ENABLE_SLIMNAVIGATION');
		if(!this.$store.getters.presentation || self.pid != this.$store.getters.presentation.id) {
			this.init();
		} else if(!this.$store.getters.loadings.presentation && (!this.$store.getters.presentation || Object.keys(this.$store.getters.presentation).length <= 0)){
			this.init();
		}

		if(this._socketid){
			this.$store.dispatch('socket/SEND_PACKAGE', {
				name: 'start edit presentation',
				payload: this._socketid,
				time: new Date().getTime()
			});
		}
	},

	destroyed(){
		this.$store.commit('DISABLE_SLIMNAVIGATION');

		if(this._socketid){
			this.$store.dispatch('socket/SEND_PACKAGE', {
				name: 'end edit presentation',
				payload: this._socketid,
				time: new Date().getTime()
			});
		}
	},

	methods: {
		...help_rest,
		...help_chart,
		init(){
			const self = this;

			let url 	= false,
				name 	= '',
				id 		= 0;
			if(self.pid){
				console.log('self.pid', self.pid)
				name = 'presentation';
				id = self.pid;

				if(!(self.$store.getters.presentation && self.pid == self.$store.getters.presentation.id)) {
					console.log(
						'debug presentation',
						!(self.$store.getters.presentation && self.pid == self.$store.getters.presentation.id),
						self.$store.getters.presentation.id, self.pid,
						self.pid == self.$store.getters.presentation.id);

					url = this.$store.getters.channel.urls.presentation.replace(':id:', self.pid);
				}
			} else if(this.master){
				console.log('this.master', this.master)
				url = this.$store.getters.channel.urls.presentation.replace(':id:', 'master');
				name = 'master';
				id = 'master';
			} else if(this.$route.params.uid){
				console.log('this.$route.params.uid', this.$route.params.uid)
				name = 'user';
				id = this.$route.params.uid;
				if(self.$store.getters.edituser) {
					// user was allready loaded
					self.$store.dispatch('SET_PRESENTATION', self.$store.getters.edituser.presentation);
				} else {
					url = this.$store.getters.channel.urls.user.replace(':id:', id);
				}
			} else if(this.$route.params.id){
				console.log('this.$route.params.id', this.$route.params.id)
				name = 'page';
				id = this.$route.params.id;
				if(self.$store.getters.edituser) {
					// user was allready loaded
					self.$store.dispatch('SET_PRESENTATION', self.$store.getters.edituser.presentation);
				} else {
					url = '/api/v1/' + this.$route.name.split('-')[0] + 's' + '/' + id;

					// url = this.$store.getters.channel.urls.user.replace(':id:', id);
				}
			}

			if(id) this._socketid = id;

			if(url) {
				this.reset();

				this.restget(url, name)
				.then(data => {
					if(!data) console.error('could not get presentation');
					self.$store.commit('START_LOADING', 'setupCharts');
					if(data.presentation) {
						self.$store.dispatch('SET_EDITUSER', data);
					} else {
						self.$store.dispatch('SET_PRESENTATION', data);
					}

					return true;
				})
				.then(data => {
					self.getChartTemplates()
					.then(charttemplates => {
						// fallback
						const charts = self.$store.getters.charts;
						if(charts){
							Object.keys(charts).forEach(function(k){
								self.setupChart(charts[k]);
							});
						}
						return data;
					});
				})
				.then(data => {
					self.$store.commit('END_LOADING', 'setupCharts');
				})
				.catch(error => {
					console.error(error);
				});
			} else if(self.$store.getters.charts) {
				self.getChartTemplates()
					.then(charttemplates => {
						// fallback
						const charts = self.$store.getters.charts;
						if(charts){
							Object.keys(charts).forEach(function(k){
								self.setupChart(charts[k]);
							});
						}
					});
			}
		},
		routerupdate(){
			this.$store.commit('RESET_ACTIVE_FIELD');
		},

		addAbleChartsByChart(chartid){
			if(chartid){
				let chart = this.$store.getters.getChartById(chartid);
				if(chart && chart.addablecharts) {
					return chart.addablecharts;
				}
			}

			return this.$store.getters.presentation.addablecharts;
		},

		reset(resetui){
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		}
	}
}
</script>

<style scoped>
.html2canvas-container {
	min-width: 1600px !important;
	min-height: 900px !important;
}
.animatefast {
	animation-duration: 300ms;
}
</style>



// WEBPACK FOOTER //
// src/pages/p-editor.vue